import React, { Component }from "react";
import Row from "reactstrap/lib/Row";
import  { Col } from "reactstrap/lib";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import { Icon } from "@material-ui/core";
import CONSTANTS from "../../../constants";
import SelectList from "../../global/form/select";


class UserBadgeHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            badgeHistory : [],
            isEditBadge: false
        }
    }

    componentDidMount(){
        this.fetchUserBadgeHistory();
    }

    fetchUserBadgeHistory = async () => {
        store.dispatch(setLoader(true))
        try{
            var body = { user_id : this.props.user_id }
            let resp = await ApiEndpoints.UserProfile.fetchUserBadgeHistory(body)
            let badgeHistory = resp.data.data
            this.setState({ badgeHistory })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

    updateBadge = async () => {
        let { isEditBadge } = this.state;
        store.dispatch(setLoader(true));
        try{
            if([0, 1, 2, 3].indexOf(Number(isEditBadge.badge_level)) === -1) {
                this.setState({ isEditBadge: false })
                return store.dispatch(setLoader(false))
            }
            var body = { user_id : this.props.user_id, badge_level: isEditBadge.badge_level }
            await ApiEndpoints.UserProfile.updateBadgeManually(body)
            this.setState({ isEditBadge: false });
            this.fetchUserBadgeHistory();
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

      
    
    render() {
        let { badgeHistory, isEditBadge } = this.state;
        return (
            <div className="px-1">
                <Row className="my-3">
                    <Col xs={1}>
                        <Icon fontSize="small" style={{cursor: "pointer"}} className="mr-3 align-middle" onClick={() => this.props.onBack()}>arrow_back</Icon>
                    </Col>
                    <Col><span>Badge History</span></Col>
                    <Col xs="auto">
                        <Button color="danger" size="sm" className="small py-0" onClick={() => this.setState({ isEditBadge: {} })}>Update Badge</Button>
                    </Col>
                </Row>
                {
                    !!isEditBadge && 
                    <div className="shadow-sm my-3 py-2">
                        <Row>
                            <Col>
                                <SelectList value={isEditBadge.badge_level} onChange={(e) => {isEditBadge.badge_level = e.target.value; this.setState({ isEditBadge }) } }>
                                    <option value={""}>Select Badge</option>
                                    <option value={0}>Bronze</option>
                                    <option value={1}>Silver</option>
                                    <option value={2}>Gold</option>
                                    <option value={3}>Diamond </option>
                                </SelectList>
                            </Col>
                            <Col className="">
                                <Icon style={{fontSize: 16}} className="clickable" onClick={() => this.setState({ isEditBadge: false })}>close</Icon>
                                <Icon style={{fontSize: 16}} className="ml-3 clickable" onClick={() => this.updateBadge()}>done</Icon>
                            </Col>
                        </Row>
                    </div>
                }
                {badgeHistory.length ? badgeHistory.map(obj => 
                    <Row style={{fontSize: 14, borderRadius: 12}} className="bg-light border align-items-center py-1 my-2" >
                        <Col xs={1}>
                            <img src={require('../../../assets/images/' + CONSTANTS.badgeConfig[obj.badge_level].iconSvgName)} alt='' style={{height:"20px"}} />
                        </Col>
                        <Col xs={5}>
                            <span className="d-block font-weight-bold" style={{color: CONSTANTS.badgeConfig[obj.badge_level].baseColor}}>{ CONSTANTS.badgeConfig[obj.badge_level].name }</span>
                            <span className="d-block small">{moment(obj.created_on).format("Do MMM'YY") }</span>
                        </Col>
                        <Col xs={6} className="text-right">
                            <span>{moment(obj.start_date).format("Do MMM'YY")} - { moment(obj.end_date).format("Do MMM'YY") }</span>
                        </Col>
                    </Row>
                ) : <em className="m-4 text-secondary d-block">No Badge History Found</em> }
                     
                   
            </div>
           
        );
    }
}
export default UserBadgeHistory;
